export default "__VITE_ASSET__DynyL$2x__"